<div
  [ngClass]="{ 'cart-status': true, 'cart-status--pale': quoteOrdering }"
  class="cart-status"
  [matBadge]="itemCount$ | async"
  [matBadgePosition]="'above after'"
  [matBadgeColor]="'warn'">
  <spx-icon-button [type]="'mat-icon-button'" [iconFilePath]="'assets/icons/icon-shop.svg'" (click)="onShoppingCartClick()"></spx-icon-button>
</div>
